import { ExclamationCircleOutlined, MailOutlined, SafetyOutlined } from '@ant-design/icons'
import { Button, Card, Radio, Tag, Typography, Modal as AntdModal } from 'antd'
import OTPInput from 'components/OTP'
import Switch from 'components/Switch/Switch.index'
import React, { useEffect } from 'react'
import TwoFactorAuthModal, { TFA_METHODS } from './components/TwoFactorAuthModal'
import { useDispatch, useSelector } from 'react-redux'
import { getConfigByKey } from 'services/misc.service'
import { changeTFAPreference, verifyUser } from 'services/auth.services'
const { confirm } = AntdModal;

const PreferredTFAMethod = {
    Email: 1,
    Phone: 0

}

export default function TFA() {

    const dispatch = useDispatch();

    const [enabled, setEnabled] = React.useState(false);
    const [showPopup, setShowPopup] = React.useState(null);

    const user = useSelector(state => state.user.currentUser)
    const { phoneNumberConfirmed, emailConfirmed, preferredTwoFactorVerificationMode, phoneNumber, email, staffId } = user


    const [tfaExpiry, setTfaExpiry] = React.useState();
    const [shouldLoadSettings, setShouldLoadSettings] = React.useState(false);
    const [loadingSettings, setLoadingSettings] = React.useState(false);

    useEffect(() => {
        const loadData = async () => {
            setLoadingSettings(true)
            const res = await dispatch(getConfigByKey('Totp:ExpiryInMinutes', false))
            if (res?.status === 'success') {
                // backend stores value as string; parse to number
                const val = res.data?.value
                const n = val !== undefined && val !== null ? Number(val) : null
                setTfaExpiry(Number.isFinite(n) ? n : null)
            }
            setLoadingSettings(false)
        }

        if (shouldLoadSettings) {
            loadData();
        }
    }, [shouldLoadSettings])


    async function changePreference(preference) {
        const res = await dispatch(changeTFAPreference(staffId, {
            email, phoneNumber, twoFactorVerificationMode: preference
        }))
        if (res?.status === 'success') {
            dispatch(verifyUser())
        }
    }


    return (
        <div style={{
            padding: 16,
        }} className="settingsContainer">
            <Card style={{ borderRadius: 8, boxShadow: '0px 5px 10px #dfe2e8' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>

                    <div style={{ display: 'flex', gap: 16 }}>
                        {/* <div size={46} icon={<SafetyOutlined style={{ color: '#16a34a'}} />}
              style={{ minWidth: 46, backgroundColor: 'rgb(34 197 94 / 0.1)' }}
              > */}
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: 46, height: 46, backgroundColor: 'rgb(34 197 94 / 0.1)', borderRadius: 23 }}>
                            <SafetyOutlined style={{ color: '#16a34a', fontSize: 20 }} />
                        </div>
                        <div>
                            <Typography.Title level={4} style={{ margin: 0 }}>Two-Factor Authentication</Typography.Title>
                            <Typography.Text style={{ color: '#666', fontSize: 15 }}>Account protection status</Typography.Text>
                        </div>
                    </div>

                    {/* <Switch checked={true}
                        checkedChildren="ON"
                        unCheckedChildren="OFF"
                    /> */}
                </div>
            </Card >

            <Card style={{ borderRadius: 8, boxShadow: '0px 5px 10px #dfe2e8', marginTop: 16 }}>
                <div style={{ marginBottom: 16 }}>
                    <Typography.Title level={4} style={{ margin: 0 }}>Verification Method</Typography.Title>
                    <Typography.Text style={{ color: '#666', fontSize: 15 }}>Choose how you want to receive verification codes</Typography.Text>
                </div>

                <div style={{ borderRadius: 8, padding: 18, border: '1px solid #f0f0f0', marginBottom: 16 }} >
                    <div style={{ display: 'flex', }}>

                        <div style={{ display: 'flex', gap: 16, justifyContent: 'space-between', width: '100%' }}>
                            <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
                                <div>
                                    <div style={{ marginBottom: 4 }}>

                                        <MailOutlined style={{ fontSize: 20, marginRight: 8, }} />
                                        <Typography.Text style={{ fontWeight: 600, fontSize: 16, margin: 0, position: 'relative', top: 2 }}>Email</Typography.Text>
                                    </div>
                                    <Typography.Text style={{ color: '#666', fontSize: 14, display: 'block', marginBottom: 4 }}>Send verification codes to your email address</Typography.Text>
                                    {
                                        emailConfirmed ? <Tag color="green">Active</Tag> : <Tag color="red">Not Active</Tag>
                                    }
                                    {
                                        emailConfirmed && preferredTwoFactorVerificationMode === PreferredTFAMethod.Email && <Tag color="green">Prefered</Tag>
                                    }
                                </div>

                            </div>
                            <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
                                {
                                    emailConfirmed && preferredTwoFactorVerificationMode !== PreferredTFAMethod.Email && <Button type='text' onClick={() => {
                                        changePreference(PreferredTFAMethod.Email)

                                    }}>  Set as preferred </Button>
                                }

                                {
                                    emailConfirmed && <Button type='text' onClick={() => {

                                        confirm({
                                            title: "Warning",
                                            content: (
                                                <>Changing email will log you out. Are you sure?</>
                                            ),
                                            centered: true,
                                            maskClosable: true,
                                            onOk: (close) => {
                                                setShowPopup(TFA_METHODS.email)
                                                close()
                                            },
                                        })

                                    }}>  Change </Button>
                                }
                                {/* {
                                    emailConfirmed ? <Button disabled={true} type='text' onClick={() => setShowPopup(TFA_METHODS.email)}>
                                        Disable
                                    </Button> : <Button type='text' onClick={() => setShowPopup(TFA_METHODS.email)}>  Enable </Button>
                                } */}
                                {
                                    !emailConfirmed && <Button type='text' onClick={() => setShowPopup(TFA_METHODS.email)}>  Enable </Button>
                                }
                            </div>

                        </div>

                    </div>
                </div>

                <div style={{ borderRadius: 8, padding: 18, border: '1px solid #f0f0f0' }} >
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div style={{ display: 'flex', gap: 16, justifyContent: 'space-between', width: '100%' }}>
                            <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
                                <div>
                                    <div style={{ marginBottom: 4 }}>

                                        <MailOutlined style={{ fontSize: 20, marginRight: 8, }} />
                                        <Typography.Text style={{ fontWeight: 600, fontSize: 16, margin: 0, position: 'relative', top: 2 }}>SMS</Typography.Text>
                                    </div>
                                    <Typography.Text style={{ color: '#666', fontSize: 14, display: 'block', marginBottom: 4 }}>Send verification codes via text message</Typography.Text>
                                    {
                                        phoneNumberConfirmed ? <Tag color="green">Active</Tag> : <Tag color="red">Not Active</Tag>
                                    }
                                    {
                                        emailConfirmed && preferredTwoFactorVerificationMode === PreferredTFAMethod.Phone && <Tag color="green">Prefered</Tag>
                                    }
                                </div>

                            </div>

                            <div style={{ display: 'flex', gap: 8 }}>

                                {
                                    phoneNumberConfirmed && preferredTwoFactorVerificationMode !== PreferredTFAMethod.Phone && <Button type='text' onClick={() => {
                                        changePreference(PreferredTFAMethod.Phone)
                                    }}>  Set as preferred </Button>
                                }
                                {/* {
                                phoneNumberConfirmed ? <Button disabled={true} type='text' onClick={() => setShowPopup(TFA_METHODS.sms)}>
                                    Disable
                                </Button> : <Button type='text' onClick={() => setShowPopup(TFA_METHODS.sms)}>  Enable </Button>
                            } */}
                                {
                                    phoneNumberConfirmed && <Button type='text' onClick={() => setShowPopup(TFA_METHODS.sms)}>  Change </Button>
                                }
                                {
                                    !phoneNumberConfirmed && <Button type='text' onClick={() => setShowPopup(TFA_METHODS.sms)}>  Enable </Button>
                                }
                            </div>

                            <TwoFactorAuthModal visible={showPopup} type={showPopup} onClose={() => setShowPopup(null)}
                                loadingSettings={loadingSettings} tfaExpiry={tfaExpiry} onLoad={() => setShouldLoadSettings(true)}

                            />
                        </div>

                    </div>
                </div>
            </Card>
        </div >
    )
}
